import { Component } from '@angular/core';
import { PageOptimizationBase } from '../base/base.component';

@Component({
  selector: 'app-components-specialist-actioncomponents-page-optimization-implement-content',
  templateUrl: './implement-content.component.html'
})
export class PageOptimizationImplementContentComponent extends PageOptimizationBase {
  isStepReadyToReject(): boolean {
    return false;
  }
}